import { log } from 'async';

const selectFields = document.querySelectorAll(
	'.block-program-selector__select'
);

const disciplineField = document.querySelector(
	'.block-program-selector__select[name="discipline"]'
);

const programBtn = document.querySelector(
	'.block-program-selector__titles button:first-child'
);
const courseBtn = document.querySelector(
	'.block-program-selector__titles button:last-child'
);

const programFields = ['experience', 'semester', 'destination', 'discipline'];
const programValues = {};
const programMessage = document.querySelector(
	'.block-program-selector__message-program'
);

const courseFields = ['discipline', 'semester', 'destination'];
const courseValues = {};
const courseMessage = document.querySelector(
	'.block-program-selector__message-course'
);

const sectionWrapper = document
	.querySelector('.block-program-selector__titles')
	.closest('.block-program-selector');

const initSelectFields = () => {
	if (selectFields.length) {
		selectFields.forEach((selectField) => {
			selectField.addEventListener('change', selectFieldChanged);
		});
	}
};

const resizeSelectFields = () => {
	if (selectFields.length) {
		selectFields.forEach((selectField) => {
			selectFieldChanged(selectField);
		});
	}
};

const selectFieldChanged = (e) => {
	let selectField;

	if (e.currentTarget) {
		selectField = e.currentTarget;
	} else {
		selectField = e;
	}

	if (
		selectField.name &&
		'experience' === selectField.name &&
		disciplineField
	) {
		if (
			selectField.selectedIndex &&
			selectField.options[selectField.selectedIndex].text.includes(
				'internship'
			) &&
			!selectField.options[selectField.selectedIndex].text.includes(
				'study + internship'
			)
		) {
			disciplineField.parentElement.classList.add('internship-selected');
			disciplineField.disabled = true;
		} else {
			disciplineField.parentElement.classList.remove(
				'internship-selected'
			);
			disciplineField.disabled = false;
		}
	}

	if (selectField.nextElementSibling) {
		selectField.style.removeProperty('padding-left');
		selectField.style.removeProperty('padding-right');
		selectField.style.removeProperty('width');

		selectField.nextElementSibling.innerText =
			selectField.options[selectField.selectedIndex].text;

		// const selectWidth = selectField.offsetWidth;
		// const placeholderWidth = selectField.nextElementSibling.offsetWidth;
		// const padding = (selectWidth - placeholderWidth - 32) / 2;
		// selectField.style.setProperty(
		// 	'width',
		// 	selectWidth / 16 + 'rem',
		// 	'important'
		// );

		// selectField.style.setProperty(
		// 	'padding-left',
		// 	padding / 16 + 'rem',
		// 	'important'
		// );

		// selectField.style.setProperty(
		// 	'padding-right',
		// 	(padding + 30) / 16 + 'rem',
		// 	'important'
		// );
	}
};

const handleButtonClick = () => {
	programBtn.addEventListener('click', function () {
		sectionWrapper.classList.remove('block-program-selector__active');

		programBtn.classList.add('active');
		courseBtn.classList.remove('active');
		courseMessage.classList.add('d-none');
	});

	courseBtn.addEventListener('click', function () {
		sectionWrapper.classList.add('block-program-selector__active');

		courseBtn.classList.add('active');
		programBtn.classList.remove('active');
		programMessage.classList.add('d-none');
	});
};

// Program Form Handler function
function handleProgramFormSubmit(event) {
	event.preventDefault();

	const programForm = this;

	// Collect values in one pass
	programFields.forEach((field) => {
		programValues[field] = document.getElementById(
			`program-page-block-2-${field}`
		).value;
	});

	// Build query params from non-empty values
	const programParams = new URLSearchParams();
	Object.entries(programValues).forEach(([key, value]) => {
		if (value) programParams.append(key, value);
	});

	const programUrl = `/wp-json/wp/v2/program_card${
		programParams.toString() ? `?${programParams}` : ''
	}`;

	fetch(programUrl)
		.then((response) => response.json())
		.then((data) => {
			if (data.length === 0) {
				programMessage.classList.remove('d-none');
			} else {
				programMessage.classList.add('d-none');
				programForm.submit();
			}
		});
}

// Program Form Handler function
function handleCourseFormSubmit(event) {
	event.preventDefault();

	const courseForm = this;

	// Collect values in one pass
	courseFields.forEach((field) => {
		courseValues[field] = document.getElementById(
			`course-page-block-2-${field}`
		).value;
	});

	// Build query params from non-empty values
	const courseParams = new URLSearchParams();
	Object.entries(courseValues).forEach(([key, value]) => {
		if (value) courseParams.append(key, value);
	});

	const courseUrl = `/wp-json/wp/v2/course_card${
		courseParams.toString() ? `?${courseParams}` : ''
	}`;

	fetch(courseUrl)
		.then((response) => response.json())
		.then((data) => {
			if (data.length === 0) {
				courseMessage.classList.remove('d-none');
			} else {
				courseMessage.classList.add('d-none');
				courseForm.submit();
			}
		});
}

document
	.getElementById('form-program')
	.addEventListener('submit', handleProgramFormSubmit);

document
	.getElementById('form-course')
	.addEventListener('submit', handleCourseFormSubmit);

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		initSelectFields();
		resizeSelectFields();
		handleButtonClick();
	},
	loaded() {
		resizeSelectFields();
		handleButtonClick();
	},
	resized() {
		resizeSelectFields();
	},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller;
